module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "logo"
    }
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('div', {
    staticClass: "sprite stumpthespread"
  })])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "login-holder"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.currentUser),
      expression: "!currentUser"
    }]
  }, [_c('a', {
    staticClass: "sml-btn green",
    attrs: {
      "id": "login-link",
      "href": "#login-box"
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    staticClass: "sml-btn red",
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("\n          Register For Free\n        ")])], 1), _vm._v(" "), (_vm.currentUser) ? _c('div', [_vm._v("\n        " + _vm._s(_vm.currentUser.email) + "   \n        "), _c('router-link', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "to": {
        path: '/viewpicks'
      }
    }
  }, [_vm._v("\n          View Picks\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "grey"
    },
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout()
      }
    }
  }, [_vm._v("Logout")]), _vm._v("\n             \n          "), (!_vm.currentUser.admin) ? _c('router-link', {
    staticStyle: {
      "color": "grey"
    },
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("\n            My Account\n          ")]) : _vm._e(), _vm._v(" "), (_vm.currentUser.admin) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/admin'
      }
    }
  }, [_c('font', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("\n              Admin\n            ")])], 1) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "4px"
    }
  }, [_c('ul', {
    staticClass: "sf-menu"
  }, [_c('li', {
    class: {
      current_page_item: this.$route.name === 'home'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("\n            Home\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.path.indexOf('packages') > 0,
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n            Premium Picks\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n                All Sports Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nfl'
      }
    }
  }, [_vm._v("\n                NFL Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/ncaaf'
      }
    }
  }, [_vm._v("\n                NCAAF Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nba'
      }
    }
  }, [_vm._v("\n                NBA Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/ncaab'
      }
    }
  }, [_vm._v("\n                NCAAB Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/mlb'
      }
    }
  }, [_vm._v("\n                MLB Packages\n              ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nhl'
      }
    }
  }, [_vm._v("\n                NHL Packages\n              ")])], 1)])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'freepicks'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'freepicks'
      }
    }
  }, [_vm._v("\n            Free Picks\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'blog'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/blog'
      }
    }
  }, [_vm._v("\n            Blog\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'contact'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/contact'
      }
    }
  }, [_vm._v("\n            Contact\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'testimonials'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/testimonials'
      }
    }
  }, [_vm._v("\n            Testimonials\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'faq'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/faq'
      }
    }
  }, [_vm._v("\n            FAQ\n          ")])], 1), _vm._v(" "), _c('li', {
    class: {
      current_page_item: this.$route.name === 'odds'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/odds'
      }
    }
  }, [_vm._v("\n            Odds\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "#"
    }
  }, [_vm._v("\n            Tools\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tools/size'
      }
    }
  }, [_vm._v("\n                Bet Sizing Calculator\n              ")])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "shop-menu-item",
    class: {
      current_page_item: this.$route.path.indexOf('shop') > -1 || this.$route.path.indexOf('cart') > -1
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.currentUser && _vm.cartItemCount > 0 ? '/cart' : {
        name: 'shop'
      }
    }
  }, [_vm._v("\n            Shop\n            "), (_vm.currentUser && _vm.cartItemCount > 0) ? _c('span', {
    staticClass: "cart-badge"
  }, [_vm._v(_vm._s(_vm.cartItemCount))]) : _vm._e()])], 1)])]), _vm._v(" "), (!_vm.isHome && _vm.bc) ? _c('div', {
    attrs: {
      "id": "pagename"
    }
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', [_vm._v(_vm._s(_vm.bc.meta.breadcrumb))]), _vm._v(" "), _c('p', {
    staticClass: "breadcrumbs"
  }, [_vm._v("\n          You are here :\n          "), _c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("\n            Home\n          ")]), _vm._v("\n          / " + _vm._s(_vm.params.sport ? _vm.params.sport.toUpperCase() : _vm.bc.meta.subtitle) + "\n        ")], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isHome) ? _c('div', {
    attrs: {
      "id": "slider-holder"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "slider"
    }
  }, [_c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stsbutton slide-img",
    attrs: {
      "width": "200",
      "height": "200"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Free Pick")]), _vm._v(" "), (_vm.pick) ? _c('p', [_vm._v("\n              " + _vm._s(_vm.pick.title) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.pick) ? _c('p', {
    staticClass: "truncate",
    attrs: {
      "id": "freePickContent"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.pick.content)
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn grey",
    attrs: {
      "to": {
        name: 'freepicks'
      }
    }
  }, [_vm._v("\n              More Free Picks\n            ")]), _vm._v(">\n            "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("\n              Become a Free Member\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n              Buy Premium Picks\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stsblue slide-img",
    attrs: {
      "width": "200",
      "height": "200"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("NHL Full Season Package")]), _vm._v(" "), _c('p', [_vm._v("\n              STS is ready to dominate the ice this season. Our team has\n              poured hundreds of hours over the offseason to make sure we are\n              delivering the best hockey picks possible. No team is more\n              prepared for the 2019-2020 hockey season! Get $100 off our Full\n              NHL Season Package which includes premium picks every single day\n              and playoff picks. This is a 33% saving! Join today, offer ends\n              a week before the regular season!"), _c('router-link', {
    attrs: {
      "to": {
        path: '/packages/nhl'
      }
    }
  }, [_c('font', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("\n                  Purchase a full NHL season for $299.99!\n                ")])], 1)], 1), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/nhl'
      }
    }
  }, [_vm._v("\n              Purchase NHL Full Season Package\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stsredcheck slide-img"
  }), _vm._v(" "), _c('h2', [_vm._v("NCAAB Full Season Package")]), _vm._v(" "), _c('p', [_vm._v("\n              NCAAB continues to be one of our big money makers at\n              Stumpthespread. We’ve consistently put up strong profits year in\n              and year out in college basketball racking up nearly +500 units\n              all time. Last season we sprinted to the finish over the last\n              two months putting up +150 units through February and March, and\n              we’re looking to carry over that momentum into this campaign.\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/ncaab'
      }
    }
  }, [_vm._v("\n              Purchase NCAAB Full Season Package\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "slide"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "sprite stspoker slide-img"
  }), _vm._v(" "), _c('h2', [_vm._v("Testimonials")]), _vm._v(" "), _c('p', [_vm._v("You Will Win!")]), _vm._v(" "), (_vm.testimonial) ? _c('p', [_vm._v("\n              " + _vm._s(_vm.testimonial.content) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn grey",
    attrs: {
      "to": {
        name: 'freepicks'
      }
    }
  }, [_vm._v("\n              More Free Picks\n            ")]), _vm._v(">\n            "), _c('router-link', {
    staticClass: "big-btn black",
    attrs: {
      "to": {
        path: '/register'
      }
    }
  }, [_vm._v("\n              Become a Free Member\n            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "big-btn red",
    attrs: {
      "to": {
        path: '/packages/all'
      }
    }
  }, [_vm._v("\n              Buy Premium Picks\n            ")])], 1)])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "slider-nav-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "slider-nav"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sprite slider-nav-right",
    staticStyle: {
      "float": "left"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a20c2c56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StsHeader.vue
// module id = 521
// module chunks = 1